export const actionTypes = {
  REQUEST_START: 'CONTACTS.APPOINTMENT.GET_SLOTS.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.APPOINTMENT.GET_SLOTS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.APPOINTMENT.GET_SLOTS.REQUEST_FAILURE',
};

export function startRequest(taxAuthorityId, serviceId) {
  return {
    type: actionTypes.REQUEST_START,
    payload: { taxAuthorityId, serviceId },
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
